export const ViewOrderActionTypes = {
    API_RESPONSE_SUCCESS: '@@view-order/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@view-order/API_RESPONSE_ERROR',
    GET_ORDER: '@@view-order/GET_ORDER',
    GET_ORDER_TRACKING_EVENTS: '@@view-order/GET_ORDER_TRACKING_EVENTS',
    RESET_STATE: '@@view-order/RESET_STATE',
};
